export enum DocumentRequestType {
  AdditionalHRD = 'AdditionalHRD',
  BackSidePoiAndProperPOA = 'BackSidePoiAndProperPOA',
  FrontSidePoiAndAddressClarification = 'FrontSidePoiAndAddressClarification',
  BackSidePoiAndAddress = 'BackSidePoiAndAddress',
  KYCAdditionalPoa = 'KYCAdditionalPoa',
  RequestTin = 'RequestTin',
  AdditionalLeiCode = 'AdditionalLeiCode',
  AdditionalDssNumber = 'AdditionalDssNumber',
  AdditionalRenewedPassport = 'AdditionalRenewedPassport',
  AdditionalRenewedIdentity = 'AdditionalRenewedIdentity',
  AdditionalRenewedDrivingLicense = 'AdditionalRenewedDrivingLicense',
  FrontSidePoiAndPoa = 'FrontSidePoiAndPoa',
  BackSidePoiAndPOA = 'BackSidePoiAndPOA',
  AdditionalPoaAndAddressClarification = 'AdditionalPoaAndAddressClarification',
  AdditionalPoiAndAddressClarification = 'AdditionalPoiAndAddressClarification',
  AdditionalPoiAndPoaEnglish = 'AdditionalPoiAndPoaEnglish',
  RequestPOIAndPOA = 'RequestPOIAndPOA',
  AdditionalProofOfAddress = 'AdditionalProofOfAddress',
  RequestPOINigeriaNINSlipProvided = 'RequestPOINigeriaNINSlipProvided',
  RequestPOINigeria = 'RequestPOINigeria',
  RequestPOINigeriaNINAddress = 'RequestPOINigeriaNINAddress',
  RequestPOIIndia = 'RequestPOIIndia',
  RequestPOIPhillipines = 'RequestPOIPhillipines',
  RequestNameClarification = 'RequestNameClarification',
  RequestDateOfBirthClarification = 'RequestDateOfBirthClarification',
  ChinesePoa = 'ChinesePoa',
  RequestCountryMismatch = 'RequestCountryMismatch',
  RequestInvalidPhoneNumber = 'RequestInvalidPhoneNumber',
}
